webpackJsonp([1],{

/***/ 1061:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1062:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1063:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1064:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_pc_01.297d3c7.png";

/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1065)

var Component = __webpack_require__(27)(
  /* script */
  null,
  /* template */
  __webpack_require__(1102),
  /* scopeId */
  "data-v-4541ae5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1068)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1106),
  /* scopeId */
  "data-v-54f09b74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1069)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1107),
  /* scopeId */
  "data-v-6707b9a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1070)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1108),
  /* scopeId */
  "data-v-716aaf4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1072)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1110),
  /* scopeId */
  "data-v-b66bca16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1067)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1105),
  /* scopeId */
  "data-v-52236af1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1071)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1109),
  /* scopeId */
  "data-v-7f029666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1062)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  "data-v-0a9d9c46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1066)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1061)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  "data-v-06892382",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1063)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  "data-v-300cc5b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(27)(
  /* script */
  null,
  /* template */
  __webpack_require__(1101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(27)(
  /* script */
  null,
  /* template */
  __webpack_require__(1103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sex", $$v)
      },
      expression: "editForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.editForm.age),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "age", $$v)
      },
      expression: "editForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "birth", $$v)
      },
      expression: "editForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addr", $$v)
      },
      expression: "editForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.addForm.age),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "age", $$v)
      },
      expression: "addForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addr", $$v)
      },
      expression: "addForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F6F8FE",
      "height": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("\n\t\t\t\t 返回\n\t\t\t ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "addEnterprises"
  }, [_c('div', {
    staticClass: "accinfo"
  }, [_c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("数据类型")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("DataTypeFilter")(this.DataType)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("患者编号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.Code))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("患者姓名")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.PersonName))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("订单日期")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.DateRecord))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("所属医院")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.Hospital))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("文件码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCode))])]), _vm._v(" "), _vm._m(0), _c('div', {
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("H5连接")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": 'http://112.125.27.239:3801/#/case/' + this.FileCode,
      "target": "_blank"
    }
  }, [_vm._v("http://112.125.27.239:3801/#/case/" + _vm._s(this.FileCode))])])]), _vm._v(" "), _vm._m(1), _c('div', {
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-40px"
    },
    attrs: {
      "id": "qrcode1"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("CT文件")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCodeStatus))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("Dicom")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.FileCodeDcmStatus))])])]), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "alterBtn",
    on: {
      "click": _vm.alterBtn
    }
  }, [_vm._v("修改")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("App二维码")]), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "row-label"
  }, [_vm._v("H5二维码")]), _vm._v(" "), _c('span')])
}]}

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动区域"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动性质"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "美食/餐厅线上活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "地推活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "线下主题活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "单纯品牌曝光",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特殊资源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.$set(_vm.form, "resource", $$v)
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "线上品牌商赞助"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "线下场地免费"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动形式"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUser
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1099:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vuex 测试")]), _vm._v("\n  Clicked: " + _vm._s(_vm.getCount) + " times\n  "), _c('button', {
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v("-")])])
},staticRenderFns: []}

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page5...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page6...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticClass: "upLoadBtn",
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("上传")])], 1), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "placeholder": "通过编号/患者姓名/文件编码搜索",
      "maxlength": 10
    },
    model: {
      value: (_vm.input3),
      callback: function($$v) {
        _vm.input3 = $$v
      },
      expression: "input3"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.searchBtn
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "margin-top": "-30px",
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("文件列表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "150px",
      "margin-top": "-35px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeHandler
    },
    model: {
      value: (_vm.dataType),
      callback: function($$v) {
        _vm.dataType = $$v
      },
      expression: "dataType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("肺")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("泌尿")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("神外")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "3"
    }
  }, [_vm._v("肝胆")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "4"
    }
  }, [_vm._v("心脏")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "5"
    }
  }, [_vm._v("胰腺")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "6"
    }
  }, [_vm._v("甲状腺")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "7"
    }
  }, [_vm._v("耳鼻喉")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "8"
    }
  }, [_vm._v("食管")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "9"
    }
  }, [_vm._v("纵膈")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "10"
    }
  }, [_vm._v("胸外")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "11"
    }
  }, [_vm._v("普外")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "12"
    }
  }, [_vm._v("骨科")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "13"
    }
  }, [_vm._v("乳腺")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "14"
    }
  }, [_vm._v("妇科")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "15"
    }
  }, [_vm._v("胃肠")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "16"
    }
  }, [_vm._v("血管")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "17"
    }
  }, [_vm._v("腹腔")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "18"
    }
  }, [_vm._v("盆腔")])], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.changeSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "70px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FileNo",
      "label": "编号",
      "align": "center",
      "min-width": "95"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DataType",
      "label": "数据类型",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("DataTypeFilter")(scope.row.DataType)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PatientName",
      "label": "患者姓名",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderTime",
      "label": "订单日期",
      "align": "center",
      "min-width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FileCode",
      "label": "文件码",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Hospital",
      "label": "所属医院",
      "align": "center",
      "min-width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "上传日期",
      "align": "center",
      "min-width": "170",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Available",
      "label": "状态",
      "align": "center",
      "min-width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Available == 0 ? "可用" : "停用"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "editBtn",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 15,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F6F8FE",
      "height": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("\n\t\t\t 返回\n\t\t ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "addEnterprises"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules1,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "数据类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择数据类型"
    },
    model: {
      value: (_vm.dataTypeValue),
      callback: function($$v) {
        _vm.dataTypeValue = $$v
      },
      expression: "dataTypeValue"
    }
  }, _vm._l((_vm.dataOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "患者编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者编号 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.FileNo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "FileNo", $$v)
      },
      expression: "ruleForm.FileNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PatientName",
      "label": "患者姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者姓名 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.PatientName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "PatientName", $$v)
      },
      expression: "ruleForm.PatientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "OrderTime",
      "label": "订单日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.OrderTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "OrderTime", $$v)
      },
      expression: "ruleForm.OrderTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Hospital",
      "label": "所属医院"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入所属医院 (最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.Hospital),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "Hospital", $$v)
      },
      expression: "ruleForm.Hospital"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "TimeInterval",
      "label": "CT间隔"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.timeIntervalDisabled,
      "placeholder": "请输入CT间隔 (范围值在0.125-5,单位为mm)",
      "maxlength": 6
    },
    model: {
      value: (_vm.ruleForm.TimeInterval),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "TimeInterval", $$v)
      },
      expression: "ruleForm.TimeInterval"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "submit marleft"
  }, [_c('el-button', {
    staticClass: "upLoadBtn",
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "font-size": "14px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("\n\t\t\t\t\t\t确认上传\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "500px",
      "height": "300px",
      "margin-left": "500px",
      "margin-top": "-450px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "middle"
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct1upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT1,
      "on-preview": _vm.handlePreview_CT1,
      "on-remove": _vm.handleRemove_CT1,
      "on-success": _vm.handleSuccess_CT1,
      "before-remove": _vm.beforeRemove_CT1,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT1,
      "file-list": _vm.fileList_CT1
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT1,
      "size": "middle"
    }
  }, [_vm._v("CT文件1")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT1))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct2upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT2,
      "on-preview": _vm.handlePreview_CT2,
      "on-remove": _vm.handleRemove_CT2,
      "on-success": _vm.handleSuccess_CT2,
      "before-remove": _vm.beforeRemove_CT2,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT2,
      "file-list": _vm.fileList_CT2
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT2,
      "size": "middle"
    }
  }, [_vm._v("CT文件2")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT2))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct3upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT3,
      "on-preview": _vm.handlePreview_DCM,
      "on-remove": _vm.handleRemove_CT3,
      "on-success": _vm.handleSuccess_CT3,
      "before-remove": _vm.beforeRemove_CT3,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT3,
      "file-list": _vm.fileList_CT3
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT3,
      "size": "middle"
    }
  }, [_vm._v("CT文件3")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT3))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct4upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT3,
      "on-preview": _vm.handlePreview_DCM,
      "on-remove": _vm.handleRemove_DCM,
      "on-success": _vm.handleSuccess_DCM,
      "before-remove": _vm.beforeRemove_DCM,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_DCM,
      "file-list": _vm.fileList_DCM
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_DCM,
      "size": "middle"
    }
  }, [_vm._v("Dicom文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_DCM))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticStyle: {
      "width": "125px",
      "height": "32px",
      "margin-top": "13px",
      "margin-left": "40px"
    },
    attrs: {
      "src": __webpack_require__(1079)
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('div', {
      staticClass: "menu-row"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n\t\t\t\t\t\t")])]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#F6F8FE",
      "height": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("\n\t\t\t 返回\n\t\t ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "addEnterprises"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules1,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "数据类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择数据类型"
    },
    model: {
      value: (_vm.dataTypeValue),
      callback: function($$v) {
        _vm.dataTypeValue = $$v
      },
      expression: "dataTypeValue"
    }
  }, _vm._l((_vm.dataOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "FileNo",
      "label": "患者编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者编号(最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.FileNo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "FileNo", $$v)
      },
      expression: "ruleForm.FileNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PatientName",
      "label": "患者姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者姓名(最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.PatientName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "PatientName", $$v)
      },
      expression: "ruleForm.PatientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "OrderTime",
      "label": "订单日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.OrderTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "OrderTime", $$v)
      },
      expression: "ruleForm.OrderTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Hospital",
      "label": "所属医院"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入所属医院(最长16位字符)",
      "maxlength": 16
    },
    model: {
      value: (_vm.ruleForm.Hospital),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "Hospital", $$v)
      },
      expression: "ruleForm.Hospital"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "TimeInterval",
      "label": "CT间隔"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.timeIntervalDisabled,
      "placeholder": "请输入CT间隔 (范围值在0.125-5,单位为mm)",
      "maxlength": 6
    },
    model: {
      value: (_vm.ruleForm.TimeInterval),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "TimeInterval", $$v)
      },
      expression: "ruleForm.TimeInterval"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "submit marleft"
  }, [_c('el-button', {
    staticClass: "upLoadBtn",
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "font-size": "14px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.alterFile
    }
  }, [_vm._v("\n\t\t\t\t\t\t确认修改\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "500px",
      "height": "300px",
      "margin-left": "500px",
      "margin-top": "-450px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "middle"
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle))])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "ct1upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT1,
      "on-preview": _vm.handlePreview_CT1,
      "on-remove": _vm.handleRemove_CT1,
      "on-success": _vm.handleSuccess_CT1,
      "before-remove": _vm.beforeRemove_CT1,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT1,
      "file-list": _vm.fileList_CT1
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT1,
      "size": "middle"
    }
  }, [_vm._v("CT文件1")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT1))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      display: _vm.delCT1Btn
    }),
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteCT1()
      }
    }
  }, [_vm._v("删除该文件")]), _vm._v(" "), _c('el-upload', {
    staticClass: "ct2upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT2,
      "on-preview": _vm.handlePreview_CT2,
      "on-remove": _vm.handleRemove_CT2,
      "on-success": _vm.handleSuccess_CT2,
      "before-remove": _vm.beforeRemove_CT2,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT2,
      "file-list": _vm.fileList_CT2
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT2,
      "size": "middle"
    }
  }, [_vm._v("CT文件2")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT2))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      display: _vm.delCT2Btn
    }),
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteCT2()
      }
    }
  }, [_vm._v("删除该文件")]), _vm._v(" "), _c('el-upload', {
    staticClass: "ct3upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_CT3,
      "on-preview": _vm.handlePreview_CT3,
      "on-remove": _vm.handleRemove_CT3,
      "on-success": _vm.handleSuccess_CT3,
      "before-remove": _vm.beforeRemove_CT3,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_CT3,
      "file-list": _vm.fileList_CT3
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_CT3,
      "size": "middle"
    }
  }, [_vm._v("CT文件3")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_CT3))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      display: _vm.delCT3Btn
    }),
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteCT3()
      }
    }
  }, [_vm._v("删除该文件")]), _vm._v(" "), _c('el-upload', {
    staticClass: "ct4upload-demo",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "accept": ".zip",
      "action": "http://112.125.27.239:8004/ZhenYuan/UploadFile/",
      "before-upload": _vm.onBeforeUpload_DCM,
      "on-preview": _vm.handlePreview_DCM,
      "on-remove": _vm.handleRemove_DCM,
      "on-success": _vm.handleSuccess_DCM,
      "before-remove": _vm.beforeRemove_DCM,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed_DCM,
      "file-list": _vm.fileList_DCM
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "#1F6AAB"
    },
    attrs: {
      "disabled": _vm.disabled_DCM,
      "size": "middle"
    }
  }, [_vm._v("Dicom文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tipTitle_DCM))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      display: _vm.delCTDcmBtn
    }),
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteDCM()
      }
    }
  }, [_vm._v("删除该文件")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mock = __webpack_require__(454);

var _mock2 = _interopRequireDefault(_mock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mock2.default;

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(1082);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(1080);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1081);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(1083);

var _Main2 = _interopRequireDefault(_Main);

var _Table = __webpack_require__(1090);

var _Table2 = _interopRequireDefault(_Table);

var _FileList = __webpack_require__(1088);

var _FileList2 = _interopRequireDefault(_FileList);

var _AddFile = __webpack_require__(1085);

var _AddFile2 = _interopRequireDefault(_AddFile);

var _FileInfo = __webpack_require__(1087);

var _FileInfo2 = _interopRequireDefault(_FileInfo);

var _AlterFile = __webpack_require__(1086);

var _AlterFile2 = _interopRequireDefault(_AlterFile);

var _Form = __webpack_require__(1089);

var _Form2 = _interopRequireDefault(_Form);

var _user = __webpack_require__(1091);

var _user2 = _interopRequireDefault(_user);

var _Page = __webpack_require__(1092);

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__(1093);

var _Page4 = _interopRequireDefault(_Page3);

var _Page5 = __webpack_require__(1094);

var _Page6 = _interopRequireDefault(_Page5);

var _echarts = __webpack_require__(1084);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/',

    component: _Home2.default,
    name: '文件列表',
    iconCls: 'el-icon-document',
    leaf: true,
    children: [{ path: '/', component: _FileList2.default, name: '文件列表' }, { path: '/fileList', component: _FileList2.default, name: '文件列表' }, { path: '/addFile', component: _AddFile2.default, name: '新增文件', hidden: true }, { path: '/fileInfo', component: _FileInfo2.default, name: '文件详情', hidden: true }, { path: '/alterFile', component: _AlterFile2.default, name: '修改文件', hidden: true }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(34);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(177);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(455);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(456);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1064)

var Component = __webpack_require__(27)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1099),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			sysName: '振源医疗',
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(function () {});
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.name || '';
			this.sysUserAvatar = user.avatar || '';
		}
	}
};

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(132);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: '123456'
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = { username: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };

          (0, _api.requestLogin)(loginParams).then(function (data) {
            _this2.logining = false;
            var msg = data.msg,
                code = data.code,
                user = data.user;

            if (code !== 200) {
              _this2.$message({
                message: msg,
                type: 'error'
              });
            } else {
              sessionStorage.setItem('user', (0, _stringify2.default)(user));
              _this2.$router.push({ path: '/fileList' });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(698);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(132);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var validateOrderTime = function validateOrderTime(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请选择时间'));
			} else {
				callback();
			}
		};
		var validateHospital = function validateHospital(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请输入医院名称'));
			} else {
				callback();
			}
		};

		var validateTimeInterval = function validateTimeInterval(rule, value, callback) {
			if (!isNaN(value)) {
				if (parseFloat(value) < 0.125) {
					callback(new Error('请输入正确的数据值,范围值在0.125-5'));
				} else if (parseFloat(value) > 5) {
					callback(new Error('请输入正确的数据值,范围值在0.125-5'));
				} else {
					callback();
				}
			} else {
				callback(new Error('请输入正确的数据值,范围值在0.125-5'));
			}
		};

		var validateName = function validateName(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请输入姓名'));
			} else if (value.length > 32) {
				callback(new Error('姓名字符超限'));
			} else {
				callback();
			}
		};
		var validateFileNo = function validateFileNo(rule, value, callback) {
			var reg = /^[0-9a-zA-Z]{1,}$/;
			if (!reg.test(value)) {
				callback(new Error('请输入字母或者数字'));
			} else if (value.length < 6) {
				callback(new Error('请输入最少6位患者编号'));
			} else if (value.length > 32) {
				callback(new Error('长度超限'));
			} else {
				callback();
			}
		};

		return {
			dataOptions: [{
				value: 0,
				label: '肺'
			}, {
				value: 1,
				label: '泌尿'
			}, {
				value: 2,
				label: '神外'
			}, {
				value: 3,
				label: '肝胆'
			}, {
				value: 4,
				label: '心脏'
			}, {
				value: 5,
				label: '胰腺'
			}, {
				value: 6,
				label: '甲状腺'
			}, {
				value: 7,
				label: '耳鼻喉'
			}, {
				value: 8,
				label: '食管'
			}, {
				value: 9,
				label: '纵膈'
			}, {
				value: 10,
				label: '胸外'
			}, {
				value: 11,
				label: '普外'
			}, {
				value: 12,
				label: '骨科'
			}, {
				value: 13,
				label: '乳腺'
			}, {
				value: 14,
				label: '妇科'
			}, {
				value: 15,
				label: '胃肠'
			}, {
				value: 16,
				label: '血管'
			}, {
				value: 17,
				label: '腹腔'
			}, {
				value: 18,
				label: '盆腔'
			}],
			dataTypeValue: "",
			tipTitle: '请选择模型文件(*.zip)',
			tipTitle_CT1: '请选择第一个CT文件(*.zip)',
			tipTitle_CT2: '请选择第二个CT文件(*.zip)',
			tipTitle_CT3: '请选择第三个CT文件(*.zip)',
			tipTitle_DCM: '请选择Dicom文件(*.zip)',
			value1: '',
			disabled: false,
			disabled_CT1: false,
			disabled_CT2: true,
			disabled_CT3: true,
			disabled_DCM: false,
			timeIntervalDisabled: true,
			fileList: [],
			fileList_CT1: [],
			fileList_CT2: [],
			fileList_CT3: [],
			fileList_DCM: [],
			CTFileUrlNum: 0,
			rules1: {

				FileNo: [{ required: true, trigger: 'blur', validator: validateFileNo }],
				PatientName: [{ required: true, trigger: 'blur', validator: validateName }],
				OrderTime: [{ required: true, trigger: 'blur', validator: validateOrderTime }],
				Hospital: [{ required: true, trigger: 'blur', validator: validateHospital }],
				TimeInterval: [{ required: true, trigger: 'blur', validator: validateTimeInterval }]
			},
			ruleForm: {
				PatientName: "",
				OrderTime: "",
				Hospital: "",
				FileNo: "",
				FileUrl: "",
				CTFileUrl1: "",
				CTFileUrl2: "",
				CTFileUrl3: "",
				CTFileUrlDcm: "",
				TimeInterval: "1"
			}
		};
	},
	created: function created() {},
	activated: function activated() {},

	methods: {
		backBtn: function backBtn() {
			this.$router.push({ path: "/FileList" });
		},
		onBeforeUpload: function onBeforeUpload(file) {
			this.disabled = true;
			console.log('onBeforeUpload');
			console.log(file);
		},
		onBeforeUpload_CT1: function onBeforeUpload_CT1(file) {
			this.disabled_CT1 = true;
		},
		onBeforeUpload_CT2: function onBeforeUpload_CT2(file) {
			this.disabled_CT2 = true;
		},
		onBeforeUpload_CT3: function onBeforeUpload_CT3(file) {
			if (this.ruleForm.CTFileUrl2.indexOf("http://") != -1) {
				this.disabled_CT3 = false;
			} else {
				this.disabled_CT3 = true;
			}
		},
		handlePreview: function handlePreview(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT1: function handlePreview_CT1(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT2: function handlePreview_CT2(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT3: function handlePreview_CT3(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_DCM: function handlePreview_DCM(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handleExceed: function handleExceed(files, fileList) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT1: function handleExceed_CT1(files, fileList_CT1) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT2: function handleExceed_CT2(files, fileList_CT2) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT3: function handleExceed_CT3(files, fileList_CT3) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_DCM: function handleExceed_DCM(files, fileList_DCM) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleSuccess: function handleSuccess(response, file, fileList) {
			console.log('handleSuccess');
			console.log(response);
			console.log(response.FileUrl);
			this.ruleForm.FileUrl = response.FileUrl;
			this.tipTitle = file.name;
			this.disabled = true;
		},
		handleSuccess_CT1: function handleSuccess_CT1(response, file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = response.FileUrl;
			this.tipTitle_CT1 = file.name;
			this.disabled_CT1 = true;
			this.disabled_CT2 = false;
			this.timeIntervalDisabled = false;
		},
		handleSuccess_CT2: function handleSuccess_CT2(response, file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = response.FileUrl;
			this.tipTitle_CT2 = file.name;
			this.disabled_CT2 = true;
			this.disabled_CT3 = false;
		},
		handleSuccess_CT3: function handleSuccess_CT3(response, file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = response.FileUrl;
			this.tipTitle_CT3 = file.name;
			this.disabled_CT3 = true;
		},
		handleSuccess_DCM: function handleSuccess_DCM(response, file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = response.FileUrl;
			this.tipTitle_DCM = file.name;
			this.disabled_DCM = true;
		},
		handleRemove: function handleRemove(file, fileList) {
			this.ruleForm.FileUrl = '';
			this.tipTitle = '请选择模型文件(*.zip)';
			this.disabled = false;
		},
		handleRemove_CT1: function handleRemove_CT1(file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = '';
			this.tipTitle_CT1 = '请选择第一个CT文件(*.zip)';
			this.disabled_CT1 = false;
		},
		handleRemove_CT2: function handleRemove_CT2(file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = '';
			this.tipTitle_CT2 = '请选择第二个CT文件(*.zip)';
			this.disabled_CT2 = false;
		},
		handleRemove_CT3: function handleRemove_CT3(file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = '';
			this.tipTitle_CT3 = '请选择第三个CT文件(*.zip)';
			this.disabled_CT3 = false;
		},
		handleRemove_DCM: function handleRemove_DCM(file, fileList_CT3) {
			this.ruleForm.CTFileUrlDcm = '';
			this.tipTitle_DCM = '请选择Dicom文件(*.zip)';
			this.disabled_DCM = false;
		},
		beforeRemove: function beforeRemove(file, fileList) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT1: function beforeRemove_CT1(file, fileList_CT1) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT2: function beforeRemove_CT2(file, fileList_CT2) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT3: function beforeRemove_CT3(file, fileList_CT3) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_DCM: function beforeRemove_DCM(file, fileList_DCM) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		addFile: function addFile() {
			var _this = this;

			this.$refs.ruleForm.validate(function (valid) {
				if (valid) {
					if (_this.ruleForm.FileUrl == '') {
						_this.$message({
							title: "error",
							message: "请选择模型文件(*.zip)",
							type: "error"
						});
					} else {
						var data = {};
						console.log(_this.ruleForm.OrderTime);

						data.PatientName = _this.ruleForm.PatientName;
						data.OrderTime = _this.ruleForm.OrderTime;
						data.Hospital = _this.ruleForm.Hospital;

						data.FileNo = _this.ruleForm.FileNo;
						data.FileUrl = _this.ruleForm.FileUrl;
						data.CTFileUrl1 = _this.ruleForm.CTFileUrl1;
						data.CTFileUrl2 = _this.ruleForm.CTFileUrl2;
						data.CTFileUrl3 = _this.ruleForm.CTFileUrl3;
						data.CTFileUrlDcm = _this.ruleForm.CTFileUrlDcm;
						data.TimeInterval = _this.ruleForm.TimeInterval;
						data.DataType = _this.dataTypeValue;

						var ctFileList = [data.CTFileUrl1, data.CTFileUrl2, data.CTFileUrl3, data.CTFileUrlDcm];

						console.log("ctFileList = " + ctFileList);

						for (var ctfile in ctFileList) {
							console.log("ctfile = " + ctFileList[ctfile]);

							if (ctFileList[ctfile].indexOf("http://") != -1) {
								_this.CTFileUrlNum++;
								console.log("this.CTFileUrlNum++ = " + _this.CTFileUrlNum);
							}
						}

						data.CTFileUrlNum = _this.CTFileUrlNum;
						console.log(data);
						(0, _api.AddFile)(data).then(function (res) {
							console.log(res);

							if ((0, _stringify2.default)(res) == '{}') {
								_this.$message({
									title: "error",
									message: "上传文件失败",
									type: "error"
								});
							} else {
								_this.$message({
									title: "success",
									message: "上传文件成功",
									type: "success"
								});

								_this.$router.push({ path: "/fileList" });
							}

							_this.CTFileUrlNum = 0;
						});
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		}
	}
};

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(132);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var validateOrderTime = function validateOrderTime(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请选择时间'));
			} else {
				callback();
			}
		};
		var validateHospital = function validateHospital(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请输入医院名称'));
			} else {
				callback();
			}
		};

		var validateTimeInterval = function validateTimeInterval(rule, value, callback) {
			if (!isNaN(value)) {
				if (parseFloat(value) < 0.125) {
					callback(new Error('请输入正确的数据值,范围值在0.125-5'));
				} else if (parseFloat(value) > 5) {
					callback(new Error('请输入正确的数据值,范围值在0.125-5'));
				} else {
					callback();
				}
			} else {
				callback(new Error('请输入正确的数据值,范围值在0.125-5'));
			}
		};

		var validateName = function validateName(rule, value, callback) {
			if (value.length < 1) {
				callback(new Error('请输入姓名'));
			} else if (value.length > 32) {
				callback(new Error('姓名字符超限'));
			} else {
				callback();
			}
		};
		var validateFileNo = function validateFileNo(rule, value, callback) {
			var reg = /^[0-9a-zA-Z]{1,}$/;
			if (!reg.test(value)) {
				callback(new Error('请输入字母或者数字'));
			} else if (value.length < 6) {
				callback(new Error('请输入至少6位患者编号'));
			} else if (value.length > 32) {
				callback(new Error('编号字符超限'));
			} else {
				callback();
			}
		};

		return {
			dataOptions: [{
				value: 0,
				label: '肺'
			}, {
				value: 1,
				label: '泌尿'
			}, {
				value: 2,
				label: '神外'
			}, {
				value: 3,
				label: '肝胆'
			}, {
				value: 4,
				label: '心脏'
			}, {
				value: 5,
				label: '胰腺'
			}, {
				value: 6,
				label: '甲状腺'
			}, {
				value: 7,
				label: '耳鼻喉'
			}, {
				value: 8,
				label: '食管'
			}, {
				value: 9,
				label: '纵膈'
			}, {
				value: 10,
				label: '胸外'
			}, {
				value: 11,
				label: '普外'
			}, {
				value: 12,
				label: '骨科'
			}, {
				value: 13,
				label: '乳腺'
			}, {
				value: 14,
				label: '妇科'
			}, {
				value: 15,
				label: '胃肠'
			}, {
				value: 16,
				label: '血管'
			}, {
				value: 17,
				label: '腹腔'
			}, {
				value: 18,
				label: '盆腔'
			}],
			dataTypeValue: "",
			tipTitle: '请选择模型文件(*.zip)',
			tipTitle_CT1: '请选择第一个CT文件(*.zip)',
			tipTitle_CT2: '请选择第二个CT文件(*.zip)',
			tipTitle_CT3: '请选择第三个CT文件(*.zip)',
			tipTitle_DCM: '请选择Dicom文件(*.zip)',
			value1: '',
			delCT1Btn: "none",
			delCT2Btn: "none",
			delCT3Btn: "none",
			delCTDcmBtn: "none",
			disabled: false,
			disabled_CT1: false,
			disabled_CT2: true,
			disabled_CT3: true,
			disabled_DCM: false,
			timeIntervalDisabled: true,
			fileList: [],
			fileList_CT1: [],
			fileList_CT2: [],
			fileList_CT3: [],
			fileList_DCM: [],
			CTFileUrlNum: 0,
			rules1: {
				FileNo: [{ required: true, trigger: 'blur', validator: validateFileNo }],
				PatientName: [{ required: true, trigger: 'blur', validator: validateName }],
				OrderTime: [{ required: true, trigger: 'blur', validator: validateOrderTime }],
				Hospital: [{ required: true, trigger: 'blur', validator: validateHospital }],
				TimeInterval: [{ required: true, trigger: 'blur', validator: validateTimeInterval }]

			},
			ruleForm: {
				PatientName: "",
				OrderTime: "",
				Hospital: "",
				FileNo: "",
				FileUrl: "",
				CTFileUrl1: "",
				CTFileUrl2: "",
				CTFileUrl3: "",
				CTFileUrlDcm: "",
				TimeInterval: ""
			}
		};
	},
	created: function created() {
		console.log("created");
		console.log(this.$route.query);

		var fileData = this.$route.query;

		this.dataTypeValue = this.dataOptions[parseInt(fileData.DataType)].label;

		this.ruleForm.TimeInterval = fileData.TimeInterval;

		this.ruleForm.PatientName = fileData.PersonName;
		this.ruleForm.FileNo = fileData.Code;
		this.ruleForm.OrderTime = fileData.DateRecord;
		this.ruleForm.Hospital = fileData.Hospital;

		this.ruleForm.FileUrl = fileData.DownUrl;
		this.tipTitle = fileData.DownUrl.split("tools")[1].substring(17);


		if (fileData.CTFileUrl1.indexOf("http:") != -1) {
			this.ruleForm.CTFileUrl1 = fileData.CTFileUrl1;
			this.tipTitle_CT1 = fileData.CTFileUrl1.split("tools")[1].substring(17);
			this.disabled_CT2 = false;
			this.timeIntervalDisabled = false;
			this.delCT1Btn = "";
		}
		if (fileData.CTFileUrl2.indexOf("http:") != -1) {
			this.ruleForm.CTFileUrl2 = fileData.CTFileUrl2;
			this.tipTitle_CT2 = fileData.CTFileUrl2.split("tools")[1].substring(17);
			this.disabled_CT3 = false;
			this.delCT2Btn = "";
		}
		if (fileData.CTFileUrl3.indexOf("http:") != -1) {
			this.ruleForm.CTFileUrl3 = fileData.CTFileUrl3;
			this.tipTitle_CT3 = fileData.CTFileUrl3.split("tools")[1].substring(17);
			this.delCT3Btn = "";
		}
		if (fileData.CTFileUrlDcm.indexOf("http:") != -1) {
			this.ruleForm.CTFileUrlDcm = fileData.CTFileUrlDcm;
			this.tipTitle_DCM = fileData.CTFileUrlDcm.split("tools")[1].substring(17);
			this.delCTDcmBtn = "";
		}
	},
	activated: function activated() {},

	methods: {
		deleteCT1: function deleteCT1() {
			this.ruleForm.CTFileUrl1 = "";
			this.delCT1Btn = "none";
			this.tipTitle_CT1 = "请选择第一个CT文件(*.zip)";
		},
		deleteCT2: function deleteCT2() {
			this.delCT2Btn = "none";
			this.ruleForm.CTFileUrl2 = "";

			this.tipTitle_CT2 = "请选择第二个CT文件(*.zip)";
		},
		deleteCT3: function deleteCT3() {
			this.delCT3Btn = "none";
			this.ruleForm.CTFileUrl3 = "";
			this.tipTitle_CT3 = "请选择第三个CT文件(*.zip)";
		},
		deleteDCM: function deleteDCM() {
			this.delCTDcmBtn = "none";
			this.ruleForm.CTFileUrlDcm = "";
			this.tipTitle_DCM = "请选择Dicom文件(*.zip)";
		},
		backBtn: function backBtn() {
			this.$router.push({ path: "/FileList" });
		},
		onBeforeUpload: function onBeforeUpload(file) {
			this.disabled = true;
			console.log('onBeforeUpload');
			console.log(file);
		},
		onBeforeUpload_CT1: function onBeforeUpload_CT1(file) {
			this.disabled_CT1 = true;
		},
		onBeforeUpload_CT2: function onBeforeUpload_CT2(file) {
			this.disabled_CT2 = true;
		},
		onBeforeUpload_CT3: function onBeforeUpload_CT3(file) {
			this.disabled_CT3 = true;
		},
		onBeforeUpload_DCM: function onBeforeUpload_DCM(file) {
			this.disabled_DCM = true;
		},
		handlePreview: function handlePreview(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT1: function handlePreview_CT1(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT2: function handlePreview_CT2(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_CT3: function handlePreview_CT3(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handlePreview_DCM: function handlePreview_DCM(file) {
			console.log('handlePreview');
			console.log(file);
		},
		handleExceed: function handleExceed(files, fileList) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT1: function handleExceed_CT1(files, fileList_CT1) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT2: function handleExceed_CT2(files, fileList_CT2) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_CT3: function handleExceed_CT3(files, fileList_CT3) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleExceed_DCM: function handleExceed_DCM(files, fileList_DCM) {
			this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6');
		},
		handleSuccess: function handleSuccess(response, file, fileList) {
			console.log('handleSuccess');
			console.log(response);
			console.log(response.FileUrl);
			this.ruleForm.FileUrl = response.FileUrl;
			this.tipTitle = file.name;
			this.disabled = true;
		},
		handleSuccess_CT1: function handleSuccess_CT1(response, file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = response.FileUrl;
			this.tipTitle_CT1 = file.name;
			this.disabled_CT1 = true;
			this.disabled_CT2 = false;
			this.timeIntervalDisabled = false;
		},
		handleSuccess_CT2: function handleSuccess_CT2(response, file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = response.FileUrl;
			this.tipTitle_CT2 = file.name;
			this.disabled_CT2 = true;
			this.disabled_CT3 = false;
		},
		handleSuccess_CT3: function handleSuccess_CT3(response, file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = response.FileUrl;
			this.tipTitle_CT3 = file.name;
			this.disabled_CT3 = true;
		},
		handleSuccess_DCM: function handleSuccess_DCM(response, file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = response.FileUrl;
			this.tipTitle_DCM = file.name;
			this.disabled_DCM = true;
		},
		handleRemove: function handleRemove(file, fileList) {
			this.ruleForm.FileUrl = '';
			this.tipTitle = '请选择模型文件(*.zip)';
			this.disabled = false;
		},
		handleRemove_CT1: function handleRemove_CT1(file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = '';
			this.tipTitle_CT1 = '请选择第一个CT文件(*.zip)';
			this.disabled_CT1 = false;
		},
		handleRemove_CT2: function handleRemove_CT2(file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = '';
			this.tipTitle_CT2 = '请选择第二个CT文件(*.zip)';
			this.disabled_CT2 = false;
		},
		handleRemove_CT3: function handleRemove_CT3(file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = '';
			this.tipTitle_CT3 = '请选择第三个CT文件(*.zip)';
			this.disabled_CT3 = false;
		},
		handleRemove_DCM: function handleRemove_DCM(file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = '';
			this.tipTitle_DCM = '请选择Dicom文件(*.zip)';
			this.disabled_DCM = false;
		},
		beforeRemove: function beforeRemove(file, fileList) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT1: function beforeRemove_CT1(file, fileList_CT1) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT2: function beforeRemove_CT2(file, fileList_CT2) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_CT3: function beforeRemove_CT3(file, fileList_CT3) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		beforeRemove_DCM: function beforeRemove_DCM(file, fileList_DCM) {
			return this.$confirm('\u786E\u5B9A\u79FB\u9664 ' + file.name + '\uFF1F');
		},
		alterFile: function alterFile() {
			var _this = this;

			this.$refs.ruleForm.validate(function (valid) {
				if (valid) {
					if (_this.ruleForm.FileUrl == '') {
						_this.$message({
							title: "error",
							message: "请选择模型文件(*.zip)",
							type: "error"
						});
					} else {
						var data = {};

						data.FileCode = _this.$route.query.FileCode;
						data.PatientName = _this.ruleForm.PatientName;

						var orderTime = _this.ruleForm.OrderTime;
						if (orderTime instanceof Date) {
							var y = orderTime.getFullYear();
							var m = ('0' + (orderTime.getMonth() + 1)).slice(-2);
							var d = ('0' + orderTime.getDate()).slice(-2);
							orderTime = y + '-' + m + '-' + d + ' 00:00:00';
						} else if (typeof orderTime === 'string' && orderTime.length === 10) {
							orderTime = orderTime + ' 00:00:00';
						}
						data.OrderTime = orderTime;
						data.Hospital = _this.ruleForm.Hospital;
						data.FileNo = _this.ruleForm.FileNo;
						data.FileUrl = _this.ruleForm.FileUrl;
						data.CTFileUrl1 = _this.ruleForm.CTFileUrl1;
						data.CTFileUrl2 = _this.ruleForm.CTFileUrl2;
						data.CTFileUrl3 = _this.ruleForm.CTFileUrl3;
						data.CTFileUrlDcm = _this.ruleForm.CTFileUrlDcm;
						data.TimeInterval = _this.ruleForm.TimeInterval;
						console.log("this.dataTypeValue = " + _this.dataTypeValue);
						if (_this.dataTypeValue == "肺") {

							data.DataType = 0;
						} else if (_this.dataTypeValue == "泌尿") {

							data.DataType = 1;
						} else if (_this.dataTypeValue == "神外") {

							data.DataType = 2;
						} else if (_this.dataTypeValue == "肝胆") {

							data.DataType = 3;
						} else if (_this.dataTypeValue == "心脏") {

							data.DataType = 4;
						} else if (_this.dataTypeValue == "胰腺") {

							data.DataType = 5;
						} else if (_this.dataTypeValue == "甲状腺") {

							data.DataType = 6;
						} else if (_this.dataTypeValue == "耳鼻喉") {

							data.DataType = 7;
						} else if (_this.dataTypeValue == "食管") {

							data.DataType = 8;
						} else if (_this.dataTypeValue == "纵膈") {

							data.DataType = 9;
						} else if (_this.dataTypeValue == "胸外") {

							data.DataType = 10;
						} else if (_this.dataTypeValue == "普外") {

							data.DataType = 11;
						} else if (_this.dataTypeValue == "骨科") {

							data.DataType = 12;
						} else if (_this.dataTypeValue == "乳腺") {

							data.DataType = 13;
						} else if (_this.dataTypeValue == "妇科") {

							data.DataType = 14;
						} else if (_this.dataTypeValue == "胃肠") {

							data.DataType = 15;
						} else if (_this.dataTypeValue == "血管") {

							data.DataType = 16;
						} else if (_this.dataTypeValue == "腹腔") {

							data.DataType = 17;
						} else if (_this.dataTypeValue == "盆腔") {

							data.DataType = 18;
						} else {
							data.DataType = parseInt(_this.dataTypeValue);
						}

						var ctFileList = [data.CTFileUrl1, data.CTFileUrl2, data.CTFileUrl3, data.CTFileUrlDcm];

						console.log("ctFileList = " + ctFileList);

						var alterCTFileUrlNum = 0;
						for (var ctfile in ctFileList) {
							console.log(ctfile);
							console.log("ctfile = " + ctFileList[ctfile]);

							if (ctFileList[ctfile].indexOf("http:") != -1) {
								alterCTFileUrlNum++;
								console.log("alterCTFileUrlNum++ = " + alterCTFileUrlNum);
							}
						}

						data.CTFileUrlNum = alterCTFileUrlNum;
						console.log(data);
						(0, _api.AlterFile)(data).then(function (res) {
							console.log("AlterFile = " + res);

							if ((0, _stringify2.default)(res) == '{}') {
								_this.$message({
									title: "error",
									message: "修改文件失败",
									type: "error"
								});
							} else {
								_this.$message({
									title: "success",
									message: "修改文件成功",
									type: "success"
								});

								_this.$router.push({ path: "/fileList" });
							}

							_this.CTFileUrlNum = 0;
						});
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		}
	}
};

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qrcodejs = __webpack_require__(1076);

var _qrcodejs2 = _interopRequireDefault(_qrcodejs);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      value1: "",
      fileData: {},
      fileList: [],
      rules1: {},
      Code: "",
      DateRecord: "",
      DownUrl: "",
      FileCode: "",

      ModeType: "",
      Hospital: "",
      PersonName: "",
      DataType: "",
      FileCodeStatus: "",
      FileCodeDcmStatus: ""
    };
  },

  filters: {
    DataTypeFilter: function DataTypeFilter(value) {
      if (value == 0) {
        return "肺";
      } else if (value == 1) {
        return "泌尿";
      } else if (value == 2) {
        return "神外";
      } else if (value == 3) {
        return "肝胆";
      } else if (value == 4) {
        return "心脏";
      } else if (value == 5) {
        return "胰腺";
      } else if (value == 6) {
        return "甲状腺";
      } else if (value == 7) {
        return "耳鼻喉";
      } else if (value == 8) {
        return "食管";
      } else if (value == 9) {
        return "纵膈";
      } else if (value == 10) {
        return "胸外";
      } else if (value == 11) {
        return "普外";
      } else if (value == 12) {
        return "骨科";
      } else if (value == 13) {
        return "乳腺";
      } else if (value == 14) {
        return "妇科";
      } else if (value == 15) {
        return "胃肠";
      } else if (value == 16) {
        return "血管";
      } else if (value == 17) {
        return "腹腔";
      } else if (value == 18) {
        return "盆腔";
      }
    }
  },
  created: function created() {
    console.log("created FileInfo");
    console.log(this.$route.query.fileCode);
    this.FileInfo();
  },
  activated: function activated() {},

  methods: {
    alterBtn: function alterBtn() {
      this.$router.push({ path: "/alterFile", query: this.fileData });
    },

    qrcode: function qrcode(filecode) {
      var qrcode = new _qrcodejs2.default("qrcode", {
        width: 128,
        height: 128,
        text: filecode,
        colorDark: "#000",
        colorLight: "#fff"
      });
    },
    qrcode1: function qrcode1(filecode) {
      var qrcode1 = new _qrcodejs2.default("qrcode1", {
        width: 128,
        height: 128,
        text: filecode,
        colorDark: "#000",
        colorLight: "#fff"
      });
    },
    backBtn: function backBtn() {
      this.$router.push({ path: "/FileList" });
    },
    FileInfo: function FileInfo() {
      var _this = this;

      var data = {};
      data.FileCode = this.$route.query.fileCode;

      console.log("data");
      console.log(data);
      (0, _api.WebFileCode)(data).then(function (res) {
        _this.fileData = res;

        console.log(res);

        _this.Code = res.Code;
        _this.DateRecord = res.DateRecord;
        _this.FileCode = res.FileCode;
        _this.PersonName = res.PersonName;
        _this.Hospital = res.Hospital;
        _this.DataType = res.DataType;
        _this.FileCodeStatus = res.FileCodeStatus;
        _this.FileCodeDcmStatus = res.CTFileUrlDcm ? "已上传" : "未上传";
        _this.qrcode(_this.FileCode);
        _this.qrcode1("http://112.125.27.239:3801/#/case/" + _this.FileCode);
      });
    },
    handleClick: function handleClick(tab, event) {}
  }
};

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(179);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(267);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        name: ""
      },
      input3: "",
      users: [],
      total: 0,
      page: 1,
      isSort: 0,
      listLoading: false,
      sels: [],
      dataType: "-1",
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
      },

      editForm: {},

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
      },

      addForm: {}
    };
  },

  filters: {
    DataTypeFilter: function DataTypeFilter(value) {
      if (value == 0) {
        return "肺";
      } else if (value == 1) {
        return "泌尿";
      } else if (value == 2) {
        return "神外";
      } else if (value == 3) {
        return "肝胆";
      } else if (value == "4") {
        return "心脏";
      } else if (value == 5) {
        return "胰腺";
      } else if (value == 6) {
        return "甲状腺";
      } else if (value == 7) {
        return "耳鼻喉";
      } else if (value == 8) {
        return "食管";
      } else if (value == 9) {
        return "纵膈";
      } else if (value == 10) {
        return "胸外";
      } else if (value == 11) {
        return "普外";
      } else if (value == 12) {
        return "骨科";
      } else if (value == 13) {
        return "乳腺";
      } else if (value == 14) {
        return "妇科";
      } else if (value == 15) {
        return "胃肠";
      } else if (value == 16) {
        return "血管";
      } else if (value == 17) {
        return "腹腔";
      } else if (value == 18) {
        return "盆腔";
      }
    }
  },
  methods: {
    changeHandler: function changeHandler(value) {
      console.log("改变之后的值是:" + value);
      this.getUsers();
    },
    changeSort: function changeSort(column) {
      this.CurPage = 1;
      if (column.prop == "OrderTime" && column.order === "descending") {
        this.isSort = 4;
      } else if (column.prop == "OrderTime" && column.order === "ascending") {
        this.isSort = 3;
      } else if (column.prop == "CreationTime" && column.order === "descending") {
        this.isSort = 2;
      } else if (column.prop == "CreationTime" && column.order === "ascending") {
        this.isSort = 1;
      } else {
        this.isSort = 0;
      }
      this.getUsers();
    },
    searchBtn: function searchBtn() {
      this.getUsers();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    getUsers: function getUsers() {
      var _this = this;

      var para = {
        Page: this.page,
        Name: this.input3,
        IsSort: this.isSort,
        DataType: parseInt(this.dataType)
      };
      this.listLoading = true;
      console.log(para);

      (0, _api.FileList)(para).then(function (res) {
        console.log("+++++++++++++++++++++++++++++++++++++++res");
        console.log(res);
        _this.users = res.List;
        _this.total = res.total;

        _this.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;

        var para = { FileCode: row.FileCode };
        (0, _api.DeleteFile)(para).then(function (res) {
          _this2.listLoading = false;

          _this2.$message({
            message: "删除成功",
            type: "success"
          });
          _this2.getUsers();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      console.log(row.FileCode);
      this.$router.push({
        path: "/fileInfo",
        query: { fileCode: row.FileCode }
      });
    },

    handleAdd: function handleAdd() {
      this.$router.push({ path: "/addFile" });
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this3.editLoading = true;

            var para = (0, _assign2.default)({}, _this3.editForm);
            para.birth = !para.birth || para.birth == "" ? "" : _util2.default.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            (0, _api.editUser)(para).then(function (res) {
              _this3.editLoading = false;

              _this3.$message({
                message: "提交成功",
                type: "success"
              });
              _this3.$refs["editForm"].resetFields();
              _this3.editFormVisible = false;
              _this3.getUsers();
            });
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this4 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this4.addLoading = true;

            var para = (0, _assign2.default)({}, _this4.addForm);
            para.birth = !para.birth || para.birth == "" ? "" : _util2.default.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            (0, _api.addUser)(para).then(function (res) {
              _this4.addLoading = false;

              _this4.$message({
                message: "提交成功",
                type: "success"
              });
              _this4.$refs["addForm"].resetFields();
              _this4.addFormVisible = false;
              _this4.getUsers();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this5 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this5.listLoading = true;

        var para = { ids: ids };
        (0, _api.batchRemoveUser)(para).then(function (res) {
          _this5.listLoading = false;

          _this5.$message({
            message: "删除成功",
            type: "success"
          });
          _this5.getUsers();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getUsers();
  }
};

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		}
	}
};

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(179);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(267);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			users: [],
			total: 0,
			page: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			}

		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getUsers();
		},
		getUsers: function getUsers() {
			var _this = this;

			var para = {
				page: this.page,
				name: this.filters.name
			};
			this.listLoading = true;

			(0, _api.FileList)(para).then(function (res) {
				console.log(res.data);
				_this.total = res.data.total;
				_this.users = res.data.users;
				_this.listLoading = false;
			});
		},

		handleDel: function handleDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.listLoading = true;

				var para = { id: row.id };
				(0, _api.removeUser)(para).then(function (res) {
					_this2.listLoading = false;

					_this2.$message({
						message: '删除成功',
						type: 'success'
					});
					_this2.getUsers();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						var para = (0, _assign2.default)({}, _this3.editForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.editUser)(para).then(function (res) {
							_this3.editLoading = false;

							_this3.$message({
								message: '提交成功',
								type: 'success'
							});
							_this3.$refs['editForm'].resetFields();
							_this3.editFormVisible = false;
							_this3.getUsers();
						});
					});
				}
			});
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function (valid) {
				if (valid) {
					_this4.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this4.addLoading = true;

						var para = (0, _assign2.default)({}, _this4.addForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.addUser)(para).then(function (res) {
							_this4.addLoading = false;

							_this4.$message({
								message: '提交成功',
								type: 'success'
							});
							_this4.$refs['addForm'].resetFields();
							_this4.addFormVisible = false;
							_this4.getUsers();
						});
					});
				}
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item.id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then(function () {
				_this5.listLoading = true;

				var para = { ids: ids };
				(0, _api.batchRemoveUser)(para).then(function (res) {
					_this5.listLoading = false;

					_this5.$message({
						message: '删除成功',
						type: 'success'
					});
					_this5.getUsers();
				});
			}).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.getUsers();
	}
};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(72);

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			loading: false,
			users: []
		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},

		getUser: function getUser() {
			var _this = this;

			var para = {
				name: this.filters.name
			};
			this.loading = true;

			(0, _api.getUserList)(para).then(function (res) {
				_this.users = res.data.users;
				_this.loading = false;
			});
		}
	},
	mounted: function mounted() {
		this.getUser();
	}
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(459);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getCount'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['increment', 'decrement']))
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(414);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(34);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(418);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(415);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(416);

var _vueRouter = __webpack_require__(419);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(413);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(177);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(412);

var _routes2 = _interopRequireDefault(_routes);

var _mock = __webpack_require__(411);

var _mock2 = _interopRequireDefault(_mock);

__webpack_require__(417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Users = exports.LoginUsers = undefined;

var _mockjs = __webpack_require__(1075);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginUsers = [{
  id: 1,
  username: 'admin',
  password: '123456',
  avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png',
  name: '张某某'
}];

var Users = [];

for (var i = 0; i < 86; i++) {
  Users.push(_mockjs2.default.mock({
    id: _mockjs2.default.Random.guid(),
    name: _mockjs2.default.Random.cname(),
    addr: _mockjs2.default.mock('@county(true)'),
    'age|18-60': 1,
    birth: _mockjs2.default.Random.date(),
    sex: _mockjs2.default.Random.integer(0, 1)
  }));
}

exports.LoginUsers = LoginUsers;
exports.Users = Users;

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(132);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(458);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(178);

var _axios2 = _interopRequireDefault(_axios);

var _axiosMockAdapter = __webpack_require__(421);

var _axiosMockAdapter2 = _interopRequireDefault(_axiosMockAdapter);

var _user = __webpack_require__(453);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _Users = _user.Users;

exports.default = {
  bootstrap: function bootstrap() {
    var mock = new _axiosMockAdapter2.default(_axios2.default);

    mock.onGet('/success').reply(200, {
      msg: 'success'
    });

    mock.onGet('/error').reply(500, {
      msg: 'failure'
    });

    mock.onPost('/login').reply(function (config) {
      var _JSON$parse = JSON.parse(config.data),
          username = _JSON$parse.username,
          password = _JSON$parse.password;

      return new _promise2.default(function (resolve, reject) {
        var user = null;
        setTimeout(function () {
          var hasUser = _user.LoginUsers.some(function (u) {
            if (u.username === username && u.password === password) {
              user = JSON.parse((0, _stringify2.default)(u));
              user.password = undefined;
              return true;
            }
          });

          if (hasUser) {
            resolve([200, { code: 200, msg: '请求成功', user: user }]);
          } else {
            resolve([200, { code: 500, msg: '账号或密码错误' }]);
          }
        }, 1000);
      });
    });

    mock.onGet('/user/list').reply(function (config) {
      var name = config.params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/listpage').reply(function (config) {
      var _config$params = config.params,
          page = _config$params.page,
          name = _config$params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      var total = mockUsers.length;
      mockUsers = mockUsers.filter(function (u, index) {
        return index < 20 * page && index >= 20 * (page - 1);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            total: total,
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/remove').reply(function (config) {
      var id = config.params.id;

      _Users = _Users.filter(function (u) {
        return u.id !== id;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/batchremove').reply(function (config) {
      var ids = config.params.ids;

      ids = ids.split(',');
      _Users = _Users.filter(function (u) {
        return !ids.includes(u.id);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/edit').reply(function (config) {
      var _config$params2 = config.params,
          id = _config$params2.id,
          name = _config$params2.name,
          addr = _config$params2.addr,
          age = _config$params2.age,
          birth = _config$params2.birth,
          sex = _config$params2.sex;

      _Users.some(function (u) {
        if (u.id === id) {
          u.name = name;
          u.addr = addr;
          u.age = age;
          u.birth = birth;
          u.sex = sex;
          return true;
        }
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '编辑成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/add').reply(function (config) {
      var _config$params3 = config.params,
          name = _config$params3.name,
          addr = _config$params3.addr,
          age = _config$params3.age,
          birth = _config$params3.birth,
          sex = _config$params3.sex;

      _Users.push({
        name: name,
        addr: addr,
        age: age,
        birth: birth,
        sex: sex
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }]);
        }, 500);
      });
    });
  }
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = exports.DeleteFile = exports.WebFileCode = exports.AlterFile = exports.AddFile = exports.FileList = undefined;

var _axios = __webpack_require__(178);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '';

var urlBase = 'http://112.125.27.239:8004/ZhenYuan';
var FileList = exports.FileList = function FileList(params) {
	return _axios2.default.post(urlBase + '/FileList/', params).then(function (res) {
		return res.data;
	});
};
var AddFile = exports.AddFile = function AddFile(params) {
	return _axios2.default.post(urlBase + '/AddFile/', params).then(function (res) {
		return res.data;
	});
};

var AlterFile = exports.AlterFile = function AlterFile(params) {
	return _axios2.default.post(urlBase + '/AlterFile/', params).then(function (res) {
		return res.data;
	});
};

var WebFileCode = exports.WebFileCode = function WebFileCode(params) {
	return _axios2.default.post(urlBase + '/WebFileCode/', params).then(function (res) {
		return res.data;
	});
};
var DeleteFile = exports.DeleteFile = function DeleteFile(params) {
	return _axios2.default.post(urlBase + '/DeleteFile/', params).then(function (res) {
		return res.data;
	});
};

var requestLogin = exports.requestLogin = function requestLogin(params) {
	return _axios2.default.post(base + '/login', params).then(function (res) {
		return res.data;
	});
};

var getUserList = exports.getUserList = function getUserList(params) {
	return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
	return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
	return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
	return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
	return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
	return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ })

},[452]);


// WEBPACK FOOTER //
// static/js/app.f087567d59c95fa8aacd.js